export default class ProgressBar {
  constructor() {
    this._progress = document.querySelector(".jsProgressBar");
    this._progressContent = document.querySelector(".jsProgressContent");

    if (!this._progress) return;

    // helpers
    this._delay = false;
    this._contentOffset = this._progressContent.offsetTop - 1;

    this.init();
  }

  getWindowData() {
    let wHeight = window.innerHeight,
      dHeight = this._progressContent.offsetHeight,
      maxHeight = dHeight - wHeight;

    this._progress.setAttribute("max", maxHeight);
  }

  setProgressValue() {
    let value = window.scrollY;
    value = value - this._contentOffset;
    value = value < 0 ? 0 : value;

    value > 0
      ? this._progress.parentElement.classList.add("pinned")
      : this._progress.parentElement.classList.remove("pinned");

    this._progress.setAttribute("value", value);
  }

  handleScroll() {
    if (this._delay) clearTimeout(this._delay);

    this._delay = setTimeout(this.setProgressValue.bind(this), 40);
  }

  init() {
    this.getWindowData();
    this.setProgressValue();

    window.addEventListener("scroll", () => {
      this.handleScroll();
    });
  }
}
